import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "./auth/authContext";
import _ from "lodash";

export default function Header({
  title,
  disableBack,
  isUsingFragment,
  fragmentHistory,
  setFragmentHistory,
  setFragment,
  rightButton,
  rightButtonIcon,
  disabledRightButton = false,
  transparent = false,
}) {
  // navigate
  const navigate = useNavigate();
  const { userData } = useAuth();
  const validateModule =
    _.filter(userData?.module, (item) => {
      return item.action === "/user-management";
    })?.length > 0;
  const [navbarBackground, setNavbarBackground] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setNavbarBackground(true);
      } else {
        setNavbarBackground(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`fixed top-0 z-50 w-full ${navbarBackground || !transparent ? "bg-white shadow-md" : "bg-transparent"}} px-5 py-4 transition-colors`}
    >
      <div className=" mx-auto flex max-w-screen-xl items-center">
        {!disableBack && (
          <button
            className="flex-shrink-0"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (isUsingFragment) {
                let history = fragmentHistory.slice(0, -1);
                setFragmentHistory(history);
                setFragment(history[history.length - 1]);
              } else {
                const canGoBack = window.history.state.idx > 0;
                if (canGoBack) {
                  navigate(-1);
                } else {
                  navigate("/");
                }
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        )}

        <h2 className="flex-1 text-center font-bold text-gray-700">{title}</h2>

        {rightButton && (
          <button
            className="flex-shrink-0 disabled:text-gray-400"
            onClick={rightButton}
            disabled={disabledRightButton}
          >
            {rightButtonIcon}
          </button>
        )}

        {/* {validateModule && (
          <Link to="/user-management" className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M24 13.616v-3.232c-1.651-.587-2.694-.752-3.219-2.019v-.001c-.527-1.271.1-2.134.847-3.707l-2.285-2.285c-1.561.742-2.433 1.375-3.707.847h-.001c-1.269-.526-1.435-1.576-2.019-3.219h-3.232c-.582 1.635-.749 2.692-2.019 3.219h-.001c-1.271.528-2.132-.098-3.707-.847l-2.285 2.285c.745 1.568 1.375 2.434.847 3.707-.527 1.271-1.584 1.438-3.219 2.02v3.232c1.632.58 2.692.749 3.219 2.019.53 1.282-.114 2.166-.847 3.707l2.285 2.286c1.562-.743 2.434-1.375 3.707-.847h.001c1.27.526 1.436 1.579 2.019 3.219h3.232c.582-1.636.75-2.69 2.027-3.222h.001c1.262-.524 2.12.101 3.698.851l2.285-2.286c-.744-1.563-1.375-2.433-.848-3.706.527-1.271 1.588-1.44 3.221-2.021zm-12 2.384c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" />
            </svg>
          </Link>
        )} */}
      </div>
    </div>
  );
}
